export default __webpack_public_path__ + "img/631601722e8ee41b006726851cd5399f.svg";